import {
  LIST_QUEUE_REQUEST,
  LIST_QUEUE_SUCCESS,
  LIST_QUEUE_FAIL,
  CREATE_QUEUE_REQUEST,
  CREATE_QUEUE_SUCCESS,
  CREATE_QUEUE_FAIL,
  DELETE_QUEUE_REQUEST,
  DELETE_QUEUE_SUCCESS,
  DELETE_QUEUE_FAIL,
  DETAIL_QUEUE_REQUEST,
  DETAIL_QUEUE_SUCCESS,
  DETAIL_QUEUE_FAIL,
  UPDATE_QUEUE_REQUEST,
  UPDATE_QUEUE_SUCCESS,
  UPDATE_QUEUE_FAIL
} from '../../constants/queue'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingDelete: false,
  loadingDetail: false,
  queue: {},
  queues: [],
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const queueReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_QUEUE_REQUEST:
      return { ...state, loading: true, queues: [] }
    case LIST_QUEUE_SUCCESS:
      return {
        ...state,
        loading: false,
        queues: action.payload,
        pageable: action.pageable
      }
    case LIST_QUEUE_FAIL:
      return { ...state, loading: false, error: action.payload }
    case CREATE_QUEUE_REQUEST:
    case UPDATE_QUEUE_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_QUEUE_SUCCESS:
    case UPDATE_QUEUE_SUCCESS:
      return {
        ...state,
        loadingCreate: false
      }
    case CREATE_QUEUE_FAIL:
    case UPDATE_QUEUE_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DELETE_QUEUE_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_QUEUE_SUCCESS:
      return {
        ...state,
        loadingDelete: false
      }
    case DELETE_QUEUE_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case DETAIL_QUEUE_REQUEST:
      return { ...state, loadingDetail: true, queue: {} }
    case DETAIL_QUEUE_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        queue: action.payload
      }
    case DETAIL_QUEUE_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    default:
      return state
  }
}

export default queueReducer
